<template>
	<div class="pd-detail">
		<div class="pd-head">
			<v-icon small color="primary" class="mr-1">{{ esterna ? 'mdi-link-variant' : 'mdi-file-document-outline' }}</v-icon>
			<span class="pd-head-title">{{ nome || 'Pagina' }}</span>
			<v-chip x-small label class="ml-1" :color="item.is_active ? 'success' : undefined" :outlined="!item.is_active">{{ item.is_active ? 'pubblicata' : 'ritirata' }}</v-chip>
			<v-spacer></v-spacer>
			<v-btn x-small outlined color="primary" @click="$emit('edit')"><v-icon left x-small>mdi-pencil-outline</v-icon>Modifica</v-btn>
			<v-btn x-small text color="error" @click="$emit('delete')"><v-icon left x-small>mdi-delete-outline</v-icon>Elimina</v-btn>
		</div>

		<div class="pd-body">
			<div>
				<div class="pd-section">Dove si trova</div>
				<div class="pd-box pd-pad pd-small">
					<div class="pd-row">
						<span class="pd-k">Tipo</span><span>{{ esterna ? 'Link esterno' : 'Pagina di contenuto' }}</span>
					</div>
					<div class="pd-row">
						<span class="pd-k">{{ esterna ? 'Porta a' : 'Indirizzo' }}</span>
						<span class="pd-mono">{{ esterna ? item.external_link || '—' : slug ? '/' + slug : '—' }}</span>
					</div>
					<div class="pd-row">
						<span class="pd-k">Menu</span>
						<span>
							<v-chip v-if="item.menu_header" x-small label outlined color="primary" class="mr-1">header</v-chip>
							<v-chip v-if="item.menu_footer" x-small label outlined color="primary">footer</v-chip>
							<span v-if="!item.menu_header && !item.menu_footer" class="pd-muted">in nessun menu</span>
						</span>
					</div>
					<div v-if="padre" class="pd-row">
						<span class="pd-k">Dentro</span><span>{{ padre }}</span>
					</div>
					<div v-if="item.map_iframe" class="pd-row">
						<span class="pd-k">Mappa</span><span><v-icon x-small class="mr-1">mdi-map-marker-outline</v-icon>Google Maps inserita</span>
					</div>
				</div>

				<template v-if="!esterna">
					<div class="pd-section mt-4">Contenuto</div>
					<div class="pd-box pd-pad pd-small">
						<div v-if="estratto" class="pd-text">{{ estratto }}</div>
						<div v-else class="pd-muted">Nessun testo nella lingua predefinita</div>
					</div>
				</template>
			</div>

			<div>
				<div class="pd-section">Come appare su Google</div>
				<div class="pd-box pd-pad">
					<div class="pd-g-url">{{ esterna ? item.external_link : 'tuosito.it' + (slug ? ' › ' + slug : '') }}</div>
					<div class="pd-g-title">{{ metatitle || nome || 'Titolo della pagina' }}</div>
					<div class="pd-g-desc">{{ metadescription || 'Nessuna meta description: Google sceglierà un pezzo di testo della pagina.' }}</div>
					<div v-if="!metatitle || !metadescription" class="pd-muted pd-small mt-2">
						<v-icon x-small class="mr-1">mdi-information-outline</v-icon
						>{{ !metatitle && !metadescription ? 'Mancano meta title e meta description' : !metatitle ? 'Manca il meta title: si usa il nome' : 'Manca la meta description' }}
					</div>
				</div>
				<div class="pd-muted pd-small mt-2">Creata il {{ item.created_at | moment('DD/MM/YYYY') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import he from 'he';

// dettaglio di una pagina di contenuto nella lista: dove sta, cosa contiene e come la vede Google
export default {
	name: 'PageDetail',
	props: {
		item: { type: Object, required: true },
		// pagine dell'albero (getSettings.pages, appiattito) per il nome del padre
		pagine: { type: Array, default: () => [] },
		lingua: { type: String, default: '' },
	},
	computed: {
		t() {
			return this.item.trans || {};
		},
		esterna() {
			return this.item.type === 'external_link';
		},
		nome() {
			return this.decodifica(this.t.name);
		},
		slug() {
			return this.t.slug || '';
		},
		metatitle() {
			return this.decodifica(this.t.metatitle);
		},
		metadescription() {
			return this.decodifica(this.t.metadescription);
		},
		// testo semplice (niente HTML): estratto per capire cosa c'e' nella pagina
		estratto() {
			const testo = this.decodifica(this.t.text)
				.replace(/<[^>]*>/g, ' ')
				.replace(/\s+/g, ' ')
				.trim();
			return testo.length > 320 ? testo.slice(0, 320) + '…' : testo;
		},
		padre() {
			const p = (this.item.parent || [])[0];
			if (!p || p.id === undefined || p.id === null || p.id === 0) return '';
			const trovata = this.pagine.find(x => x.id === p.id);
			if (!trovata) return '';
			const tr = (trovata.trans || []).find(x => x.lang === this.lingua) || (trovata.trans || [])[0];
			return (tr && this.decodifica(tr.name)) || '';
		},
	},
	methods: {
		decodifica(v) {
			return he.decode(String(v || ''));
		},
	},
};
</script>

<style scoped>
.pd-detail {
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	white-space: normal;
}
.pd-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.pd-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.pd-body {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 16px;
	padding: 12px;
}
.pd-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.pd-muted {
	color: #5f6b7a;
}
.pd-small {
	font-size: 13px;
}
.pd-box {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
}
.pd-pad {
	padding: 10px 12px;
}
.pd-row {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 3px 0;
}
.pd-k {
	flex: 0 0 72px;
	color: #8a96a3;
	font-size: 12px;
}
.pd-mono {
	font-family: monospace;
	word-break: break-all;
}
.pd-text {
	line-height: 1.5;
	color: #1f2d3d;
}
.pd-g-url {
	font-size: 12px;
	color: #202124;
	word-break: break-all;
}
.pd-g-title {
	margin-top: 2px;
	font-size: 18px;
	line-height: 1.3;
	color: #1a0dab;
	word-break: break-word;
}
.pd-g-desc {
	margin-top: 2px;
	font-size: 13px;
	line-height: 1.45;
	color: #4d5156;
	word-break: break-word;
}
@media (max-width: 1023px) {
	.pd-body {
		grid-template-columns: 1fr;
	}
}
@media (max-width: 768px) {
	.pd-body {
		padding: 8px;
	}
}
</style>
